import { FEATURE_IDS } from 'src/tpbp-core/feature-flag/featureFlags.const'
import { hasFeature } from 'src/tpbp-core/feature-flag/featureFlags.utils'
import { CONTRAT_LINE_TYPES } from 'src/tpbp-json-api-handler/models/contract/contract-line.types'
import type { ContractLineModel } from 'src/tpbp-json-api-handler/models/models'
import {
  ALLOWED_MANDATS_PRODUCT_GROUPS,
  isLifeInsuranceWithdrawalException,
} from './contractLine.business-rules'

export function computeWithdrawalIsReadOnly(contractLine: ContractLineModel) {
  const { amountInitial, isReadOnly, isArbitrable, type, productGroup } =
    contractLine

  return (
    (isReadOnly ||
      !isArbitrable ||
      (amountInitial ?? 0) === 0 ||
      type === CONTRAT_LINE_TYPES.PROFILS ||
      (type === CONTRAT_LINE_TYPES.MANDATS &&
        !ALLOWED_MANDATS_PRODUCT_GROUPS.has(productGroup))) &&
    !isLifeInsuranceWithdrawalException(contractLine)
  )
}

export function computeWithdrawalMaxControl(
  amountInitial: number,
  withdrawal: number,
  balanceMin: number,
): number | undefined {
  if (withdrawal <= 0 || withdrawal === amountInitial) return
  if (withdrawal > amountInitial) return 0
  return amountInitial - withdrawal < balanceMin ? balanceMin : undefined
}

export function computeDepositMaxControl(
  amountInitial: number,
  maxInitialPayment: number,
  exceptionalPaymentMax: number,
  deposit: number,
) {
  return amountInitial === 0
    ? maxInitialPayment
    : deposit > 0
      ? exceptionalPaymentMax
      : undefined
}

export function computeDepositMinControl(
  amountInitial: number,
  minInitialPayment: number,
  exceptionalPaymentMin: number,
  deposit: number,
) {
  return amountInitial === 0
    ? minInitialPayment
    : deposit > 0
      ? exceptionalPaymentMin
      : undefined
}

export function computeAmountMinControl(amount: number, balanceMin: number) {
  return balanceMin && amount < balanceMin ? balanceMin : undefined
}

export function computeMonthlyAmountMaxControl(
  monthlyAmount: number,
  maxScheduledPayment: number,
  monthlyAmountInitial: number,
  hasFeatureDmpEsg: boolean,
  isEsgCriteriaCompliant: boolean,
) {
  if (monthlyAmount > 0) {
    return !hasFeatureDmpEsg || isEsgCriteriaCompliant
      ? maxScheduledPayment
      : monthlyAmountInitial
  }
  return
}

export function computeMonthlyAmountMinControl(
  monthlyAmount: number,
  minScheduledPayment: number,
  monthlyAmountInitial: number,
  pledgeAccount: boolean,
) {
  const haveErrorPledgeAccount =
    pledgeAccount && monthlyAmount < monthlyAmountInitial
  const haveError = monthlyAmount > 0 ? minScheduledPayment : undefined
  return haveErrorPledgeAccount ? monthlyAmountInitial : haveError
}

export function computeMonthlyAmountIsReadOnly(
  contractLine: ContractLineModel,
) {
  const { isReadOnly, isMonthlyPaymentPossible } = contractLine
  return !!isReadOnly || !isMonthlyPaymentPossible
}

export function computeDepositIsReadOnly({
  isReadOnly,
  isForDeposit,
  isEsgCriteriaCompliant,
  isNew,
}: ContractLineModel) {
  return (
    isReadOnly ||
    (!isNew && !isForDeposit) ||
    (hasFeature(FEATURE_IDS.dmpEsg) && !isEsgCriteriaCompliant)
  )
}
